module.exports = __webpack_public_path__ + "img/Thomas Zeinzinger.cb53c79e.jpg";